import {watch} from 'vue'
import {useEventListener} from '@vueuse/core'
import {useTaskStore} from '@toolify/client/src/stores/TaskStore/useTaskStore'
import {useNativeAppStore} from '@toolify/client/src/stores/AppTitlebarStore/useNativeAppStore'

export function useActiveTransferGuard(): void {
  const taskStore = useTaskStore()
  const nativeAppStore = useNativeAppStore()

  useEventListener(window, 'beforeunload', (event: BeforeUnloadEvent) => {
    if (!taskStore.hasAnyActiveTransferTasks) {
      return
    }
    // Uploads are not resumable, so leaving discards the whole transfer.
    // Browsers ignore custom text and show their own wording.
    event.preventDefault()
    event.returnValue = ''
  })

  watch(() => taskStore.hasAnyActiveTransferTasks, (hasActiveTransfers) => {
    void nativeAppStore.setActiveTransferState(hasActiveTransfers)
  })
}
